import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/_services/login.service';
import { ReportsService } from '../../_services/reports.service';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import * as _ from 'underscore';
import { ExcelService } from 'src/app/_services/excel.service';
import * as __ from 'lodash';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import * as FusionCharts from 'fusioncharts';
import TimeSeries from 'fusioncharts/viz/timeseries';
import FusionTheme from 'fusioncharts/themes/es/fusioncharts.theme.fusion';
import moment from 'moment';

@Component({
    selector: 'app-team-members-reports',
    templateUrl: './team-members-reports.component.html',
    styleUrls: ['./team-members-reports.component.scss'],
    providers: [ExcelService],
    standalone: false
})
export class TeamMembersReportsComponent implements OnInit {
  activityTableHeader = ['Team Members', 'Active Days', 'Searches Performed', 'Projects Created', 'Profiles Viewed', 'Contact Revealed', 'Credits Used', 'Profiles added to Pipeline', 'Mails Sent']
  activityDataList = [

  ]

  selected: boolean
  selectedActivity: any = []



  width = "100%";
  height = 400;
  type = "line";

  firstLoad: number = 0;

  users: any;
  totalUsersCount: any;
  averageContactsRevealed: any;
  averageProfileViewed: any;
  averageSearchPerformed: any;
  activeDays: any;
  chartData: any = {}
  creditData: any = {}
  originalActivityDataList: any;
  reportType:any;
  activitySelected: string = 'searches-performed';
  isNextActive: boolean = true;
  isPrevActive: boolean = false;

  
  currentSortOrder: string = 'desc'; // Initialize with 'asc'
  currentSortKey: string =  'Team Members';

  pageNumber: number = 1;
  pageSize: number = 2;
  currentPage: number = 1;
  start: any = 0; //- start number for pagination (from)
  end: any //- end number for paginatuin (to)
  batches: any;
  itemsPerPage: number = 5;

  currentCredit: number = 0;
  
  totalUsersLength: number = 0;
  constructor(private loginService: LoginService, private reportService: ReportsService, private excel: ExcelService, private localStorageService: LocalStorageService, private router:Router) { }

  ngOnInit(): void {
    
    this.reportService.fetchDataWithDate().subscribe((event: any) => {

      
      if(this.router.url.includes('team')){
        this.activitySelected = 'searches-performed';
        this.updateAllReports()
      }

    });

    this.loginService.getTagUsers('').subscribe((result: any) => {
      
      this.users = result.message

      this.users.forEach(x => {
        this.currentCredit = this.currentCredit + x.balancebasiccontactenrichmentcredits;
      })
      this.getActivityBreakdownInBulk();
     
      // this.chartData = {
      //   chart: {
      //     // caption: `Total number of ${this.reportType} over the selected date range`,
      //     "theme": "fusion",
     
      
      //     navigator: {
      //       enabled: 0 // Set enabled to 0 to hide the slider
      //     },
      //     "extensions": {
      //       "customRangeSelector": {
      //           "enabled": "0"
      //       }
      //   },  
      //   legend: {
      //     enabled: '0',
      //   },
      //     // data: null
          
      //   },

      //   data: null
        
      //   // categories: [
      //   //   {
      //   //     category: [

      //   //     ]
      //   //   }
      //   // ],
      //   // dataset: [
      //   //   {
      //   //     data: [],
      //   //   }
      //   // ]
      
      // };

      this.resetChartData();

     this.resetCreditData();


    });



  }


  getAllCount() {

    const data = {
      startdate: localStorage.getItem('startDate'),
      enddate: localStorage.getItem('endDate'),
      reporttype: 'team',
      usernumbers: this.selectedActivity.map(x => x.usernumber)
    }
    this.reportService.getAllReportsCount(data).subscribe((result: any) => {

      if (result && result.status == 'success' && result.message && result.message.activeDays > 0) {
        this.activeDays = result.message.activeDays ? result.message.activeDays : 0;
        this.averageContactsRevealed = result.message.averageContactsRevealed ? result.message.averageContactsRevealed : 0;
        this.averageProfileViewed = result.message.averageProfileViewed ? result.message.averageProfileViewed : 0;
        this.averageSearchPerformed = result.message.averageSearchPerformed ? result.message.averageSearchPerformed : 0;

      }else{
        this.activeDays = 0;
        this.averageContactsRevealed = 0;
        this.averageProfileViewed = 0;
        this.averageSearchPerformed = 0;
      }
    });
  }

  getActivityDetails(event: any = null) {

    const data = {
      startdate: localStorage.getItem('startDate'),
      enddate: localStorage.getItem('endDate'),
      activitytype: event?.target?.value ? event.target.value : 'searches-performed',
      reporttype: 'team',
      usernumbers: this.selectedActivity.map(x => x.usernumber)    
    }

    
    if(data.activitytype == 'searches-performed'){
      this.reportType = "Searches Performed"
    }else if(data.activitytype == 'active-days'){
      this.reportType = "Active Users"
    }else if(data.activitytype == 'profile-viewed'){
      this.reportType = "Profile Viewed"
    }else if(data.activitytype == 'contacts-revealed'){
      this.reportType = "Contacts Revealed"
    }

    this.reportService.getActivityDetails(data).subscribe((result: any) => {
      this.resetChartData();
      
      let aa = []
      if (result.status == 'success' && result.message && result.message.length) {
        // result.message.forEach((item) => {

          // console.log()
          result.message.forEach((item) => {
  
            let parsedDate = moment(item.activedays);
            // console.log(item.activedays, 'item.acitvedaysitem.acitvedays')
            // Format the date as per your requirement
            let formattedDate = parsedDate.format('M/D/YYYY');
            
            // console.log(formattedDate, 'formattedDateformattedDate')
            // this.chartData.data.push([ new Date(item.activedays).toISOString().split('T')[0], item.userscount ]);
            aa.push([ formattedDate, item.userscount ]);
  
          });
          // this.chartData.data.push({
          //   label: new Date(item.activedays).toISOString().split('T')[0], // Format the date
          //   value: item.userscount,
          // });
          // this.chartData.categories[0].category.push({
          //   label: new Date(item.activedays).toISOString().split('T')[0], // Format the date
          // })


        // });
        // "2023-11-25

        let timelineSearches = 'Total number of '

        if(data.activitytype == 'searches-performed'){
          this.reportType = "Searches Performed"
        }else if(data.activitytype == 'active-days'){
          this.reportType = "Users"
        }else if(data.activitytype == 'profile-viewed'){
          this.reportType = "Profile Viewed"
        }else if(data.activitytype == 'contacts-revealed'){
          this.reportType = "Contacts Revealed"
        }

        

        const all =[
          {
              "name": "Time",
              "type": "date",
              "format": "%-m/%-d/%Y",
              // "format": "%Y/%-m/%-d"
          },
          {
              "name": timelineSearches + this.reportType,
              "type": "number"
          }
        ]
      // schema[1].name = 
        // console.log(new FusionCharts.DataStore().createDataTable(aa, all), "new FusionCharts.DataStore().createDataTable(aa, all);new FusionCharts.DataStore().createDataTable(aa, all);")
        this.chartData.data = new FusionCharts.DataStore().createDataTable(aa, all);;



        

      }
    });


  }

  updateAllReports() {
    this.resetChartData();
    this.getAllCount();
    this.getActivityDetails();
    this.getCreditUsage();
    this.getActivityBreakdownInBulk();
  }

  getActivityBreakdownInBulk() {
    this.activityDataList = []
    this.users.forEach((list, count)=> {
      const data = {
        startdate: localStorage.getItem('startDate'),
        enddate: localStorage.getItem('endDate'),
        reporttype: 'team',
        usernumber: list.usernumber
      }

      this.reportService.getActivityBreakDown(data).subscribe((result: any) => {
        if (result && result.status == 'success' && result.message) {
          const firstName = list.firstname
          const lastName = list.lastname
          const actvity = result.message
          this.activityDataList.push({
            name: firstName + " " + lastName,
            acitvedays: actvity.activeDays ? actvity.activeDays : 0,
            searchperformed: actvity.totalSearch ? actvity.totalSearch : 0,
            talentpoolcreated: actvity.totalProjectCreated ? actvity.totalProjectCreated : 0,
            profilesviewed: actvity.totalProfileViewed ? actvity.totalProfileViewed : 0,
            contactrevealed: actvity.totalContactRevealed ? actvity.totalContactRevealed : 0,
            creditsused: actvity.totalCreditsUsed ? actvity.totalCreditsUsed : 0,
            profilesaddedtotalentpool: actvity.totalProfileAddedToTalentpool ? actvity.totalProfileAddedToTalentpool : 0,
            mailssent: actvity.totalMailsSent ? actvity.totalMailsSent : 0,
            selected: true,
            usernumber: list.usernumber
          })

          this.originalActivityDataList = __.cloneDeep(this.activityDataList)
    
        }
        if(count == this.users.length - 1){
          setTimeout(() => {
            this.selectedActivity = this.activityDataList
            this.initialCheckboxState = this.activityDataList.some(data => data.selected);

            
          if(this.firstLoad === 0){
            this.getAllCount();
            this.getActivityDetails();
            this.getCreditUsage();
            this.toggleSortKey('Team members')
      
          }
          this.firstLoad = this.firstLoad + 1
          },500)


        }
      });
    });
  
 }


  selectAll(value: any) {
    if (value == true) {
      this.selectedActivity = []
      this.activityDataList.forEach((element, index) => {
        this.activityDataList[index].selected = true
        this.selectedActivity.push(element)
      })
      //  this.updateAllReports()
    } else if (value == false) {
      this.activityDataList.forEach((element, index) => {

        const userNumber = this.localStorageService.getItem('usernumber');
        if(element.usernumber === userNumber){
          this.activityDataList[index].selected = true
        }else{
          this.activityDataList[index].selected = false
        }
      
        this.selectedActivity = []

      })
      this.changeReport();
    }
  }
  selectActivity(data: any, value: any) {
    if (value == true) {

      this.selectedActivity.push(data)
      if (this.selectedActivity.length === this.activityDataList.length) {
        this.selected = true

      }
      else {
        this.selected = false

      }

    }
    else if (value == false) {
      this.selectedActivity = _.without(this.selectedActivity, data)
      this.selected = false
    }

    this.changeReport();

    // this.updateAllReports()
  }

  downloadReport() {
    let downloadobj = [];

    let headers = `Name,Active days,Searches performed,Projects Created,Profiles viewed,Contact revealed,Credits used,Profiles added to Pipeline,Mails sent`;
    let filename = "Reports"

    this.selectedActivity.forEach(data => {
      let candidatelistobj = {};
      let headersmain = headers.split(",");

      headersmain.forEach((headers, index) => {
        let headersbe = headers
          .split(" ")
          .join("")
          .toLowerCase();

        //  acitvedays:10, searchperformed:10,talentpoolcreated:10,profilesviewed:10, contactrevealed:10,creditsused:10,profilesaddedtotalentpool:10,mailssent:10},

        if (headersbe == "name") {
          if (data["name"] != null) {
            candidatelistobj[headers] = data["name"];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        } else if (headersbe == "activedays") {
          if (data["acitvedays"] != null) {
            candidatelistobj[headers] = data["acitvedays"];
          } else {
            candidatelistobj[headers] = 0;
          }
        } else if (headersbe == "searchesperformed") {
          if (data["searchperformed"] != null) {
            candidatelistobj[headers] = data["searchperformed"];
          } else {
            candidatelistobj[headers] = 0;
          }
        } else if (headersbe == "projectscreated") {
          candidatelistobj[headers] = data["talentpoolcreated"] != null ? data["talentpoolcreated"] : 0;
        } else if (headersbe == "profilesaddedtopipeline") {
          candidatelistobj[headers] = data["profilesaddedtotalentpool"] != null ? data["profilesaddedtotalentpool"] : 0;
        } else {
          if (data[headersbe] != null) {
            candidatelistobj[headers] = data[headersbe];
          } else {
            candidatelistobj[headers] = 'N/A';
          }
        }
      });
      if (!_.isEmpty(candidatelistobj)) {
        downloadobj.push(candidatelistobj);
      }
    });

    let newobj = [];
    downloadobj.forEach(element => {
      newobj.push(Object.values(element));
    });



    this.excel.exportAsExcelFile(
      newobj,
      filename,
      headers.split(","),
      null
    );
  }

  getActivityBreakdown() {
    this.selectedActivity.forEach((list) => {
      const data = {
        startdate: localStorage.getItem('startDate'),
        enddate: localStorage.getItem('endDate'),
        reporttype: 'team',
        usernumber: list.usernumber
      }

      this.reportService.getActivityBreakDown(data).subscribe((result: any) => {
        if (result && result.status == 'success' && result.message) {
          const firstName = list.firstname
          const lastName = list.lastname
          const actvity = result.message
          this.activityDataList.push({
            name: firstName + " " + lastName,
            acitvedays: actvity.activeDays ? actvity.activeDays : 0,
            searchperformed: actvity.totalSearch ? actvity.totalSearch : 0,
            talentpoolcreated: actvity.totalProjectCreated ? actvity.totalProjectCreated : 0,
            profilesviewed: actvity.totalProfileViewed ? actvity.totalProfileViewed : 0,
            contactrevealed: actvity.totalContactRevealed ? actvity.totalContactRevealed : 0,
            creditsused: actvity.totalCreditsUsed ? actvity.totalCreditsUsed : 0,
            profilesaddedtotalentpool: actvity.totalProfileAddedToTalentpool ? actvity.totalProfileAddedToTalentpool : 0,
            mailssent: actvity.totalMailsSent ? actvity.totalMailsSent : 0,
            selected: true,
            usernumber: list.usernumber
          })
        }
      });
    })
  }

  getCreditUsage() {
    const data = {
      startdate: localStorage.getItem('startDate'),
      enddate: localStorage.getItem('endDate'),
      reporttype: 'team',
      usernumbers: this.selectedActivity.map(x => x.usernumber)
    }

    this.reportService.getCreditUsage(data).subscribe((result: any) => {
      if(result.message && result.message.length){
        let credit = result.message
  
        this.totalUsersLength = result.message.length
  
        this.batches = __.chunk(credit, this.itemsPerPage)
        
        this.pagination(1);
      }


    });

      // this.creditData = {
      //   chart: {  
      //     // caption: "Credit",
      //     yaxisname: "credit",
      //     flatscrollbars: "0",
      //     scrollheight: "12",
      //     numvisibleplot: "8",
      //     legendposition: "top",
      //     plottooltext:
      //       "<b>$dataValue</b> $seriesName $label",
      //       "theme": "fusion",
      //       "paletteColors": "#d9d9ff, #8585dd",
      //   },
      //   categories: [
      //     {
      //       category: [

      //       ]
      //     }
      //   ],
      //   dataset: [
      //     {
      //       data: [],
      //     }
      //   ]
      // };






      // if (result && result.status == 'success') {
      //   let creditUsed = {
      //     seriesname: "Credit Usage",
      //     data: [],

      //   }
      //   let currentCredit = {
      //     seriesname: "Current Credit",
      //     data: []

      //   }
      //   credit.forEach(list => {

      //     let user = this.users.find(x => x.userid === list.actualuserid)


      //     if (list && list.credit_usage) {
      //       let creditValue = {
      //         value: list.credit_usage
      //       }
      //       creditUsed.data.push(creditValue)
      //     } else {
      //       let creditValue = {
      //         value: 0
      //       }
      //       creditUsed.data.push(creditValue)
      //     }


      //     let currentValue = {
      //       value: list.current_credit
      //     }
      //     currentCredit.data.push(currentValue)


      //     this.creditData.categories[0].category.push({
      //       label: user.firstname + " " + user.lastname
      //     })
      //   })

      //   this.creditData.dataset.push(creditUsed)
      //   this.creditData.dataset.push(currentCredit)
      //   console.log(this.creditData, "this.creditDatathis.creditData")
        
      // }

    // });
  }


  resetChartData() {
    this.chartData = {
      "theme": "fusion",
      navigator: {
        enabled: 0 // Set enabled to 0 to hide the slider
      },
      "extensions": {
        "customRangeSelector": {
          "enabled": "0"
        },
        "standardRangeSelector": {
          "enabled": "0"
        },
      },
      "xAxis": {
        outputTimeFormat: {
          //year: "",
          // year: "%d %b %Y",
          // month: "%d %b %Y",
          day: "%d %b %Y",
          //hour: "",
          //minute: "",
          //second: "",
          //millisecond: ""
        }
      },
      
      legend: {
        enabled: '0',
      },
      data: null
    }

  }


  filterUsers(query: string) {
    if (query) {
      this.activityDataList = this.activityDataList.filter(user =>
        user.name.toLowerCase().includes(query.toLowerCase())
      );
    } else {
      this.activityDataList = this.originalActivityDataList;
    }
  }
  

  selectOption(query){
    this.activityDataList = this.activityDataList.filter(user =>
      user.name.toLowerCase().includes(query.toLowerCase())
    );
  }


  changeReport(){
    this.getAllCount();
    this.getActivityDetails();
    this.getCreditUsage();
  }


  toggleSortKey(sortKey: string) {
    this.currentSortKey = sortKey;
    this.sortAndFilterData(this.currentSortKey);
  }


  sortAndFilterData(sortKey: string) {
    this.currentSortOrder = this.currentSortOrder === 'asc' ? 'desc' : 'asc';

    // Clone the original data array to avoid modifying it directly
    const sortedAndFilteredData = this.activityDataList;
  
    // Sort the data based on the selected key
    // sortedAndFilteredData.sort((a, b) => {
    //   if (this.currentSortOrder === 'asc') {
    //     const key = this.getKeyFromHeader(sortKey);
    //     if (a[key] < b[key]) return -1;
    //     if (a[key] > b[key]) return 1;
    //   } else if (this.currentSortOrder === 'desc') {
    //     const key = this.getKeyFromHeader(sortKey);
    //     if (a[key] > b[key]) return -1;
    //     if (a[key] < b[key]) return 1;
    //   }
    //   return 0;
    // });


    sortedAndFilteredData.sort((a, b) => {
      const key = this.getKeyFromHeader(sortKey);
      const valueA = (a[key] || '').toString().toLowerCase();
      const valueB = (b[key] || '').toString().toLowerCase();
    
      if (this.currentSortOrder === 'asc') {
        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
      } else if (this.currentSortOrder === 'desc') {
        if (valueA > valueB) return -1;
        if (valueA < valueB) return 1;
      }
      return 0;
    });
    


    // sortedAndFilteredData.sort((a, b) => {
    //   if (sortKey === 'Team members') {
    //     // Sort alphabetically by "name" key
    //     return a.name.localeCompare(b.name);
    //   } else {
    //     // Sort based on the selected key
    //     const key = this.getKeyFromHeader(sortKey);

    //     return a[key] - b[key];
    //   }
    // });
  
  
    // You can add filters here if needed
    // For example, if you want to filter by a specific condition:
    // sortedAndFilteredData = sortedAndFilteredData.filter(item => item[key] > someValue);
  
    // Update the data to display the sorted and filtered results
    this.activityDataList = sortedAndFilteredData;
  }
  
  getKeyFromHeader(header: string): string {
    switch (header) {
      case 'Team members':
        return 'name';
      case 'Active Days':
        return 'acitvedays';
      case 'Searches Performed':
        return 'searchperformed';
      case 'Projects Created':
        return 'talentpoolcreated';
      case 'Profiles Viewed':
        return 'profilesviewed';
      case 'Contact Revealed':
        return 'contactrevealed';
      case 'Credits Used':
        return 'creditsused';
      case 'Profiles added to pipeline':
        return 'profilesaddedtotalentpool';
      case 'Mails Sent':
        return 'mailssent';
      default:
        return header.toLowerCase();
    }
  }

  noCheckboxSelected: boolean = false;
  initialCheckboxState: boolean;


  checkboxChanged() {
    // Check if at least one checkbox is selected after a change
    this.noCheckboxSelected = !this.activityDataList.some(data => data.selected);

    // If no checkbox is selected, revert the change
    if (this.noCheckboxSelected) {
      this.initialCheckboxState = this.activityDataList.some(data => data.selected);
    }
  }

  isLastCheckboxSelected(data) {
    // Check if the current checkbox is the last selected one
    const selectedCheckboxes = this.activityDataList.filter(item => item.selected);
    return selectedCheckboxes.length === 1 && selectedCheckboxes[0] === data;
  }

  pagination(action: any) {
    // let start = (index - 1) * this.pageSize
    // this.start = start
    // this.end = this.start + this.pageSize
    // if (this.end > this.totalCandidatesCount) {
    //   this.end = this.totalCandidatesCount
    // }
    // this.getPersonSearchRecommendedCandidates();
  
    // if(type == 'next'){
    // this.start = this.start + 1
    // }
  
    if (action === "prev") {
      // Implement logic to go to the previous page
      this.currentPage = this.currentPage - 1;
    } else if (action === "next" && !this.isLastPage()) {
      // Implement logic to go to the next page
      this.currentPage = this.currentPage + 1;
    }
  
    // this.creditData = {
    //     chart: {
    //       // caption: "Credit",
    //       yaxisname: "credit",
    //       flatscrollbars: "0",
    //       scrollheight: "12",
    //       numvisibleplot: "8",
    //       legendposition: "top",
    //       plottooltext:
    //         "<b>$dataValue</b> $seriesName $label",
    //         "theme": "fusion",
    //         "paletteColors": "#d9d9ff, #8585dd",
    //     },
    //     categories: [
    //       {
    //         category: [
  
    //         ]
    //       }
    //     ],
    //     dataset: [
    //       {
    //         seriesname: "",
    //         data: [],
    //       }
    //     ]
    //   };
  
    this.resetCreditData();
  
    // console.log(this.batches, "this.batchesthis.batches");
    if (this.batches && this.batches.length) {

      let originalData = this.batches[this.currentPage - 1]
      // Extracting unique seriesnames
      const uniqueSeriesNames = Array.from(new Set(originalData.reduce((acc, entry) => {
        const userId = Object.keys(entry)[0];
        const seriesNames = entry[userId].map(dataEntry => dataEntry.enrichedfrom);
        return acc.concat(seriesNames);
    }, [])));
    
    // Transforming the original data into the desired format
    // const categories = [{
    //     category: originalData.map(entry => ({
    //         label: Object.keys(entry)[0] // Extracting the user ID as labels
    //     }))
    // }];
    
    const categories = [{
      category: originalData.map(entry => {
          const user = this.users.find(x => x.userid == Object.keys(entry)[0]);
          return { label: `${user.firstname} ${user.lastname}` };
      })
    }];

    
  
    const dataset = uniqueSeriesNames.map(seriesName => {
        const filteredData = [];
        originalData.forEach(entry => {
            const userId = Object.keys(entry)[0];
            const userData = entry[userId];
            const matchingEntry = userData.find(dataEntry => dataEntry.enrichedfrom === seriesName);
    
            if (matchingEntry) {
                filteredData.push({ value: matchingEntry.credit_consumed });
            }else{
              filteredData.push({ value: 0 });
            }
        });


        let color = ''
        if(seriesName == 'pdl'){
          color = "#ffe3c4"
        }else if(seriesName == 'pipl'){
          color = "#a3a3f7"
        }else if(seriesName == 'nymblr'){
          color = "#95e1d3"
        }else if(seriesName == 'rocketreach'){
          color = "#ffa8a8"
        }
    
        return {
            color:color,
            seriesname: GlobalService.getProvidername(seriesName),
            data: filteredData
        };
    });
    
    

      const nameCategory = categories.map(x => x.category.forEach(y => {
        let user = this.users.find((y) => y.userid == y.label);
        // y.label = user.firstname + " " + user.lastname
      }))

      this.creditData.categories = categories
      this.creditData.dataset = dataset


      

      
      
      // this.batches[this.currentPage - 1].forEach((list) => {
      //   console.log(list, "dedede");
  
      //   console.log(
      //     Object.keys(list),
      //     "Object.keys(list)Object.keys(list)Object.keys(list)"
      //   );
      //   console.log(
      //     Object.keys(list)[0],
      //     "Object.keys(list)Object.keys(list)Object.keys(list)"
      //   );
  
      //   let user = this.users.find((x) => x.userid == Object.keys(list)[0]);
  
      //   console.log(this.users, "this.usersthis.users");
      //   console.log(user, "useruseruser");
      //   let arrValues: any = Object.values(list)[0];
      //   console.log(arrValues, "arrValuesarrValues");
      //   if (arrValues && arrValues.length) {
      //     arrValues.forEach((x: any, index: any) => {
      //       console.log(x, "dedwedew");
      //       if (x && x.credit_consumed) {
      //         let creditValue = {
      //           value: x.credit_consumed,
      //         };
      //         if (x.enrichedfrom == "pdl") {
      //           creditValue["color"] = "#ffe3c4";
      //         } else if (x.enrichedfrom == "pipl") {
      //           creditValue["color"] = "#a3a3f7";
      //         } else if (x.enrichedfrom == "nymblr") {
      //           creditValue["color"] = "#95e1d3";
      //         } else if (x.enrichedfrom == "rocketreach") {
      //           creditValue["color"] = "#ffa8a8";
      //         }
  
      //         let creditUsed = {
      //           seriesname: "",
      //           data: [],
      //         };
      //         creditUsed.seriesname = GlobalService.getProvidername(
      //           x.enrichedfrom
      //         );
      //         creditUsed.data.push(creditValue);
  
      //         console.log(creditUsed, "creditUsedcreditUsed");
      //         // let sortedData = creditUsed.data.sort((a, b) => {
      //         //   return a.seriesname > b.seriesname ? 1 : -1;
      //         // });
  
      //         this.creditData.dataset.push(creditUsed);
      //       }
      //     });
  
      //     this.creditData.dataset = this.creditData.dataset.sort((a, b) => {
      //       return a.seriesname > b.seriesname ? 1 : -1;
      //     });
  
      //     console.log(
      //       this.creditData,
      //       "this.creditDatathis.creditDatathis.creditData"
      //     );
  
      //     let a = [];
      //     this.creditData.dataset.forEach((x) => {
      //       a.push(x.seriesname);
      //     });
  
      //     let pall = [];
      //     a.forEach((y) => {
      //       pall.push(this.getColor(y));
      //     });
  
      //     let palletColor = pall && pall.length ? pall.join(",") : "";
      //     console.log(palletColor, "palletColorpalletColor");
      //     this.creditData.chart.paletteColors = palletColor;
  
      //     // let currentValue = {
      //     //   value: list.credit_consumed
      //     // }
      //     // currentCredit.data.push(currentValue)
  
      //     this.creditData.categories[0].category.push({
      //       label: user.firstname + " " + user.lastname,
      //     });
      //   }
      // });
    }
  
    // this.renderComplete();
  
    // this.creditData.dataset.push(currentCredit)
  }
  
  getStartIndex(): number {
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  getEndIndex(): number {
    // console.log(this.batches, 'dede')
    const end = this.currentPage * this.itemsPerPage;
    // console.log(end, 'endend')
    // console.log(this.users.length, 'this.users.length')

    return Math.min(Math.min(end, this.users.length), this.totalUsersLength);

    

  }

  isLastPage(): boolean {
    const totalPages = Math.ceil(this.totalUsersLength / this.itemsPerPage);
    return this.currentPage >= totalPages;
  }

  isAtFirstPage(): boolean {
    return this.currentPage <= 1;
  }

  resetCreditData() {
    this.creditData = {
      chart: {
        // caption: "Credit",
        // showvalues: "0",
        // numvisibleplot: "6",
        // plottooltext:
        //   "<b>$dataValue</b> Credit $label",
        // // theme: "candy"    
        // caption: "Credit",
        // yaxisname: "credit",
        legendposition: "top",
        // subcaption: "(As per government records)",
        flatscrollbars: "0",
        scrollheight: "12",
        numvisibleplot: "8",
        plottooltext: "$seriesName <b>$dataValue</b> ($percentValue)",
        "theme": "fusion",
        // "paletteColors": "#95e1d3, #ffe3c4, #a3a3f7, #ffa8a8",
        drawcrossline: "1",
        // showsum: "1",
        // numbersuffix: " TWh",
        "showLegend": "1"
      },
      categories: [
        {
          category: [

          ]
        }
      ],
      dataset: []
    };
  }

  renderComplete(){
    // console.log($event, 'eventevent')
    let sum = 0;

    // Calculate the total values
    for (let i = 0; i < this.creditData.data.length; i++) {
      sum += parseInt(this.creditData.data[i].value);
    }

    // Find the percentage of each data object and assign to "displayValue" attribute
    for (let i = 0; i < this.creditData.data.length; i++) {
      const percent = (Math.round((this.creditData.data[i].value / sum * 100) * 10) / 10);

      this.creditData.data[i].displayvalue = `dewdew ${this.creditData.data[i].label}, ${this.creditData.data[i].value} (${percent}%)`;
      const label = this.convertToTitleCase(GlobalService.getProvidername(this.creditData.data[i].label));
      const formattedValue = `<span style="font-weight: bold; background:red" margin:100px>${this.creditData.data[i].value}</span>`;
      const formattedPercent = `(${percent}%)`;

      // Constructing the label with left and right alignment
      const fusionChartLabel = `
        <div style="display: flex; justify-content: space-between;">
          <div>${label}</div>
          <div>${formattedValue} ${formattedPercent}</div>
        </div>
      `;

      

      // console.log(fusionChartLabel, 'fusionChartLabelfusionChartLabelfusionChartLabel')
      // this.creditData.data[i].label = fusionChartLabel;

      this.creditData.data[i].label = `${this.convertToTitleCase(GlobalService.getProvidername(this.creditData.data[i].label))},        <b>${this.creditData.data[i].value}</b> (${percent}%)`;
      // this.creditData.data[i].label = `${this.convertToTitleCase(GlobalService.getProvidername(this.creditData.data[i].label))} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ${formattedValue} (${percent}%)`;
    }



    // console.log(this.creditData, 'dwedewdewddew');

  }

  convertToTitleCase(stringName){
    stringName = stringName.toLowerCase().split(' ');
    for(let i = 0;i<stringName.length;i++){
      stringName[i] = stringName[i].charAt(0).toUpperCase() + stringName[i].slice(1);
    }
    return stringName.join(' ');
  }


  getColor(type: any){
    if(type == 'People Data Labs'){
      return "#ffe3c4"
    }else if(type == 'Pipl'){
      return "#a3a3f7"
    }else if(type == 'Nymblr'){
      return "#95e1d3"
    }else if(type  == 'RocketReach'){
      return "#ffa8a8"
    }
  }

  getTooltipText(name: any){
    if(name){
      if(name.includes('Active')){
        return 'Total number of active days in the selected time frame.'
      }else if(name.includes('Searches')){
        return 'Total number of new searches performed during the selected time frame.'
      }else if(name.includes('Profiles \n Viewed')){
        return 'Total number of profiles a user clicks into and views in the selected time frame.'
      }else if(name.includes('Projects')){
        return 'Total number of new projects created during the selected time frame.'
      }else if(name.includes('Contact')){
        return 'Total number of contact successfully revealed during the selected time frame.'
      }else if(name.includes('Credits')){
        return 'Total contact coins consumed during the selected time frame.'
      }else if(name.includes('Profiles added \nto pipeline')){
        return 'Total number of profiles added to a pipeline during the selected time frame.'
      }else if(name.includes('Mails')){
        return 'Total emails sent during the selected time.'
      }
    }
    return ''
  }

}






